"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BgLocalCheckInRangeComponentParameters = void 0;
exports.BgLocalCheckInRangeComponentParameters = [
    {
        id: 'min',
        label: 'Minimum Value',
        description: 'Input Param - Minimum bound (inclusive) of the range.',
        type: 'float',
        paramType: 'FLOAT',
        required: true,
    },
    {
        id: 'max',
        label: 'Maximum Value',
        description: 'Input Param - Maximum bound (inclusive) of the range.',
        type: 'float',
        paramType: 'FLOAT',
        required: true,
    },
    {
        id: 'value',
        label: 'Value to Check',
        description: 'Input Param - Value to be checked against the range.',
        type: 'float',
        paramType: 'FLOAT',
        required: true,
    },
    {
        id: 'inRange',
        label: 'In Range',
        description: 'Output Param - Boolean indicating if the value is within the range.',
        type: 'output',
        paramType: 'BOOLEAN',
        required: true,
    },
];
//# sourceMappingURL=BgLocalCheckInRangeComponent.js.map